/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChargebeeResponse } from '../../models/chargebee-response';

export interface GetPurchasePlans$Params {
}

export function getPurchasePlans(http: HttpClient, rootUrl: string, params?: GetPurchasePlans$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ChargebeeResponse>>> {
  const rb = new RequestBuilder(rootUrl, getPurchasePlans.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ChargebeeResponse>>;
    })
  );
}

getPurchasePlans.PATH = '/rest/purchase/plans';
